<script setup lang="ts">
import { computed } from 'vue'

import ShowMore from '../shared/ShowMore.vue'
import BroadcastList from '../../apps/tvmovie/theme/EpgSearch/BroadcastList.vue'
import { useEpgAirTimeHelper } from '../../composables/use-epg-air-time-helper'

import type { EpgBroadcastRerunsParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = withDefaults(defineProps<{
  epgBroadcastReruns: EpgBroadcastRerunsParagraph['epgBroadcastReruns'],
  listOrderPosition?: number
}>(), {
  listOrderPosition: 0
})

const { displayAirDate } = useEpgAirTimeHelper()
const broadcasts = computed(() => props.epgBroadcastReruns?.broadcasts ?? [])

// create structure for broadcast rerun list
const epgRerunData = computed(() => {
  if (!broadcasts.value.length) return

  const mapped = broadcasts.value.map(b => ({
    channel: {
      originId: b.channel?.id,
      name: b.channel?.name,
      url: b.channel?.url,
      logo: {
        imageId: b.channel?.logo?.imageId,
        height: b.channel?.logo?.height,
        width: b.channel?.logo?.width,
        mimetype: b.channel?.logo?.mimetype,
        seoName: b.channel?.logo?.seoName,
        imageAltText: b.channel?.logo?.imageAltText || '',
        imageCredit: b.channel?.logo?.imageCredit || '',
        imageCaption: b.channel?.logo?.imageCaption || '',
        crop: b.channel?.logo?.crop || null,
        focalPoint: b.channel?.logo?.focalPoint || null
      }
    },
    broadcasts: [{
      originId: b.id,
      title: displayAirDate(b.airTime), // display air date instead of title
      url: b.url,
      airTime: b.airTime,
      airTimeEnd: b.airTimeEnd,
      hasAutoPlay: b.hasAutoPlay
    }]
  }))

  // ensure chronological order
  mapped.sort((a, b) => new Date(a.broadcasts[0].airTime ?? 0).getTime() - new Date(b.broadcasts[0].airTime ?? 0).getTime())

  return mapped
})
</script>

<template>
  <div class="bx-content bx-epg bx-epg--reruns bx-typo--vod-epg bx-typo--epg">
    <h3>
      {{ broadcasts.length === 1 ? 'Wiederholung' : 'Wiederholungen' }}
    </h3>
    <ShowMore v-if="broadcasts.length"
              :controls-id="`epg-reruns-${listOrderPosition}`"
              :content-label="broadcasts.length === 1 ? 'Wiederholung' : 'Wiederholungen'"
              content-mode="list"
              :max-list-items="3"
              item-selector=".bx-epg-search__row">
      <BroadcastList :epg-data="epgRerunData" />
    </ShowMore>
  </div>
</template>
